import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);

  handleError(error: Error | unknown): void {
    if (error instanceof Error) {
      this.logger.error('Unhandled error occurred', error);
    } else {
      this.logger.error('Unhandled error occurred', { error });
    }

    // You can add additional error handling logic here
    // e.g., show user-friendly error messages, send to analytics, etc.
  }
}

